import { selectMatchEvents } from 'features/match/matchSlice';
import { getConnectedAssistEvent } from 'helpers/getConnectedEvent';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { EventTextProps } from './EventText';
import { MatchEventType } from '../../enums/matchEventType';

const EventTextGoal: React.FC<EventTextProps> = ({ matchEvent }) => {
  const matchEvents = useSelector(selectMatchEvents);

  const team = matchEvent?.team?.name;
  const player = matchEvent?.person?.name;
  const { score } = matchEvent;

  const assistEvent = getConnectedAssistEvent(matchEvents, matchEvent);

  const justTeam = team && !player && !assistEvent;
  const teamAndGoalscorer = team && player;
  const justAssist = team && !player && assistEvent;

  if (assistEvent) {
    const assistPlayerName = assistEvent?.person?.name;
    const isIndirect = assistEvent.matchEventTypeId === MatchEventType.INDIRECT_ASSIST;

    if (score && score.length > 0) {
      const assistMessageValues = { team, score, player, assistPlayerName };
      if (justAssist) {
        if (isIndirect) {
          return <FormattedMessage id="eventText.goal.justIndirectAssist" values={assistMessageValues} />;
        }
        return <FormattedMessage id="eventText.goal.justAssist" values={assistMessageValues} />;
      }

      if (isIndirect) {
        if (!assistPlayerName) {
          return <FormattedMessage id="eventText.goalScorer" values={assistMessageValues} />;
        } else {
          return <FormattedMessage id="eventText.indirectAssist" values={assistMessageValues} />;
        }
      }

      if (!assistPlayerName) {
        return <FormattedMessage id="eventText.goalScorer" values={assistMessageValues} />;
      } else {
        return <FormattedMessage id="eventText.assist" values={assistMessageValues} />;
      }
    } else {
      const assistMessageValues = { team, player, assistPlayerName };
      if (justAssist) {
        if (isIndirect) {
          return <FormattedMessage id="eventText.noScore.goal.justIndirectAssist" values={assistMessageValues} />;
        }
        return <FormattedMessage id="eventText.noScore.goal.justAssist" values={assistMessageValues} />;
      }

      if (isIndirect) {
        return <FormattedMessage id="eventText.noScore.indirectAssist" values={assistMessageValues} />;
      }

      return <FormattedMessage id="eventText.noScore.assist" values={assistMessageValues} />;
    }
  }

  if (score && score.length > 0) {
    if (teamAndGoalscorer) {
      return <FormattedMessage id="eventText.goal.teamAndGoalscorer" values={{ team, score, player }} />;
    }

    if (justTeam) {
      return <FormattedMessage id="eventText.goal.justTeam" values={{ team, score }} />;
    }
  } else {
    if (teamAndGoalscorer) {
      return <FormattedMessage id="eventText.noScore.goal.teamAndGoalscorer" values={{ team, score, player }} />;
    }

    if (justTeam) {
      return <FormattedMessage id="eventText.noScore.goal.justTeam" values={{ team, score }} />;
    }
  }

  if (score && score.length > 0) {
    return (
      <FormattedMessage
        id="eventText.goal"
        values={{
          team,
          score,
          player,
        }}
      />
    );
  } else {
    return (
      <FormattedMessage
        id="eventText.noScore.goal"
        values={{
          team,
          player,
        }}
      />
    );
  }
};

export default EventTextGoal;
